const SVGComponent = (props) => (
  <svg
    width={36}
    height={13}
    viewBox="0 0 36 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_17413_90649)">
      <path
        d="M23.4428 0.519531C20.8894 0.519531 18.6073 1.87853 18.6073 4.38882C18.6073 7.26796 22.6544 7.4668 22.6544 8.9134C22.6544 9.52249 21.9748 10.0676 20.8134 10.0676C19.1657 10.0676 17.9341 9.30591 17.9341 9.30591L17.4071 11.8395C17.4071 11.8395 18.8258 12.4829 20.7094 12.4829C23.5012 12.4829 25.6982 11.0574 25.6982 8.50389C25.6982 5.46138 21.6342 5.26845 21.6342 3.92609C21.6342 3.44894 22.1922 2.92633 23.35 2.92633C24.6564 2.92633 25.722 3.48035 25.722 3.48035L26.2379 1.03364C26.2379 1.03364 25.078 0.519531 23.4425 0.519531H23.4428ZM0.0799254 0.704329L0.0180054 1.07355C0.0180054 1.07355 1.09225 1.27535 2.05993 1.67821C3.30589 2.13983 3.39445 2.4089 3.60433 3.24344L5.89069 12.2922H8.95573L13.6775 0.704329H10.6196L7.58557 8.58298L6.34753 1.9044C6.23413 1.14008 5.65885 0.703959 4.95505 0.703959H0.0802854L0.0799254 0.704329ZM14.9072 0.704329L12.5086 12.2922H15.4246L17.8146 0.704329H14.9072ZM31.1706 0.704329C30.4675 0.704329 30.0949 1.09092 29.8217 1.76617L25.5496 12.2922H28.6074L29.1989 10.5378H32.9242L33.2838 12.2922H35.982L33.6283 0.704329H31.1706ZM31.5684 3.83517L32.4749 8.18345H30.0467L31.5688 3.83517H31.5684Z"
        fill="#1434CB"
      />
    </g>
    <defs>
      <clipPath id="clip0_17413_90649">
        <rect width={36} height={12} fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
)
export default SVGComponent
